import ConversationItemSearchHit from 'models/search/conversation_item_search_hit';
import CustomerProfileSearchHit from 'models/search/customer_profile_search_hit';
import HitTypes from 'models/search/hit_types';
import TaskSearchHit from 'models/search/task_search_hit';

export default [
  [HitTypes.CONVERSATION, ConversationItemSearchHit],
  [HitTypes.CUSTOMER_PROFILE, CustomerProfileSearchHit],
  [HitTypes.TASK, TaskSearchHit],
];
